import { Box, Divider, Typography } from "@mui/material";
import { useCallback } from "react";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../api/adminApi";
import type { Note } from "../../../api/types/notesTypes";
import { useNotesContext } from "../../notes/NotesContext";
import NotesList from "../../notes/NotesList";

const ChangeRequestsNotesSection = () => {
  const { entityType, entityId } = useNotesContext();

  const fetchNotes = useCallback(async () => adminApi.getNotes(entityType, entityId), [entityId, entityType]);

  const [notes, fetchError, { setData: setNotes }] = useFetch(fetchNotes);

  if (fetchError) {
    logError(fetchError, "[ChangeRequestsNotesSection]");
    return <DataLoadingFailed title="Failed to load notes" />;
  }

  if (notes === undefined) {
    return <InlineLoader />;
  }

  const handleNoteCreated = (note: Note) => {
    setNotes((prev) => (prev ? [note, ...prev] : [note]));
  };

  const handleNoteUpdated = (note: Note) => {
    setNotes((prev) => (prev ? prev.map((n) => (n.id === note.id ? note : n)) : [note]));
  };

  const handleNoteDeleted = (noteId: string) => {
    setNotes((prev) => (prev ? prev.filter((n) => n.id !== noteId) : []));
  };

  return (
    <Box sx={{ display: "flex", width: "100%", height: "100%" }}>
      <Divider orientation="vertical" flexItem />
      <Box sx={{ width: "100%" }}>
        <Box sx={{ px: 2.5, pt: 2.5, pb: 2, width: "100%" }}>
          <Typography variant="h6">Notes</Typography>
        </Box>
        <NotesList
          notes={notes}
          onCreated={handleNoteCreated}
          onUpdated={handleNoteUpdated}
          onDeleted={handleNoteDeleted}
        />
      </Box>
    </Box>
  );
};

export default ChangeRequestsNotesSection;
